import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import StarIcon from "@material-ui/icons/Star";

const useStyles = makeStyles(() => ({
    card: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        padding: 24,
        background: "#fff",
        height: "100%",
        transition: "0.3s",
        "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
        },
    },
    featured: {
        border: "2px solid #f59f0a",
        transform: "scale(1.03)",
    },
    badge: {
        position: "absolute",
        top: -12,
        left: "50%",
        transform: "translateX(-50%)",
        background: "#f59f0a",
        color: "#fff",
        padding: "4px 12px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        gap: 4,
    },
    title: {
        fontSize: 18,
        fontWeight: 700,
        textAlign: "center",
    },
    subtitle: {
        fontSize: 13,
        color: "#6b7280",
        textAlign: "center",
        marginBottom: 12,
    },
    price: {
        textAlign: "center",
        fontSize: 28,
        fontWeight: 800,
        color: "#111827",
        margin: "16px 0",
    },
    duration: {
        // textAlign: "center",
        fontSize: 20,
        fontWeight: 400,
        color: "#6b7280",
        // margin: "16px 0",
    },
    featureList: {
        flexGrow: 1,
        marginTop: 12,
    },
    feature: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 14,
        marginBottom: 8,
        color: "#374151",
    },
    btn: {
        marginTop: 20,
        width: "100%",
        padding: "12px 0",
        background: "linear-gradient(135deg, #ff7a18 0%, #f59f0a 100%)",
        color: "#fff",
        borderRadius: 8,
        border: "none",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 15,
    },
}));

const PlanCard = ({ plan, onBuy }) => {
    const classes = useStyles();

    const formatPrice = (price) =>
        new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        }).format(price);

    return (
        <div className={`${classes.card} ${plan.featured ? classes.featured : ""}`}>
            {plan.featured && (
                <div className={classes.badge}>
                    <StarIcon style={{ fontSize: 14 }} /> Best Value
                </div>
            )}

            <div className={classes.title}>{plan.title}</div>
            <div className={classes.subtitle}>{plan.subtitle}</div>

            <div className={classes.price}>{formatPrice(plan.price)}<small className={classes.duration}> / year</small></div>

            <div className={classes.featureList}>
                {plan.features.map((feature, idx) => (
                    <div key={idx} className={classes.feature}>
                        <CheckCircleIcon style={{ fontSize: 18, color: "#f59f0a" }} />
                        {feature}
                    </div>
                ))}
            </div>

            <button className={classes.btn} onClick={() => onBuy(plan)}>
                Buy Now
            </button>
        </div>
    );
};

export default PlanCard;
